module.exports = __webpack_public_path__ + "img/welcome-empty.6169a595.png";